import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoachBotNavigationComponent } from 'libs/coach-bot/ui/src/components';
import AuthenticationFacade from '../../../../../../apps/alpha-coach-bot/src/app/core/facades/authentication.facade';
import { LeaderboardFacade } from '../../../../../coach-bot/feature/leaderboards/src/lib/+state/leaderboard.facade';

interface DashboardLink {
  label: string;
  link: string;
  isActive?: () => boolean;
}

@Component({
  selector: 'dh-navigation',
  templateUrl: './dashboard-navigation.component.html',
  styleUrls: ['../../../../../coach-bot/ui/src/components/coach-bot-navigation/coach-bot-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardNavigationComponent extends CoachBotNavigationComponent implements OnInit {
  dashboardLinks: DashboardLink[];

  constructor(
    public authFacade: AuthenticationFacade,
    public leaderboardFacade: LeaderboardFacade,
    protected chRef: ChangeDetectorRef,
    protected router: Router,
    private translateService: TranslateService
  ) {
    super(router, chRef, leaderboardFacade, authFacade);
  }

  ngOnInit(): void {
    this.dashboardLinks = [
      {
        label: this.translateService.instant('ui.dashboard_navigation.labels.dashboard'),
        link: '/',
        isActive: () =>
          this.isTwoXLearningListActive || location.pathname === '/' || location.pathname.includes('/extension'),
      },
    ];
  }

  onLinkClick(link: DashboardLink): void {
    this._router.navigateByUrl(link.link);
  }
}
